import { combineReducers } from 'redux';
import apiReducer from './api-reducer';
import userReducer from './user-reducer';
import appStateReducer from './app-state-reducer';
import webSocketReducer from './websocket-reducer';

export default combineReducers({
  data: apiReducer,
  user: userReducer,
  appState: appStateReducer,
  ws: webSocketReducer
});
